import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage.tsx';
import Login from './pages/Login.tsx';
import Register from './pages/Register.tsx';
import Dashboard from './pages/Dashboard.tsx';
import Account from './pages/Account.tsx';
import VGP from './pages/VGP.tsx';
import LeaderBoard from './pages/LeaderBoard.tsx';
import Admin from './pages/Admin.tsx';
import { ThemeProvider } from './contexts/ThemeContext.tsx';
import { CssBaseline } from '@mui/material';
import ProtectedRoute from './components/ProtectedRoute.tsx';
import AdminProtectedRoute from './components/AdminProtectedRoute.tsx'; // Importáljuk az Admin védett útvonal komponenst
import Clicker from './pages/Clicker.tsx';
import Randomizer from './pages/Randomizer.tsx';
import Encryption from './pages/Encryption.tsx';
import CatchMe from './pages/CatchMe.tsx';
import FreeWebSites from './pages/FreeWebSites.tsx';
import FreeTrialWebSites from './pages/FreeTrialWebsites.tsx';
import PaidWebsites from './pages/PaidWebsites.tsx';
import MyScore from './pages/MyScore.tsx';
import Shop from './pages/Shop.tsx';
import CaseOpening from './pages/CaseOpening.tsx';
import BuyTokens from './pages/BuyTokens.tsx';
import MyCV from './pages/MyCV.tsx';
import PictureConverter from './pages/PictureConverter.tsx';
import AdsPage from './pages/AdsPage.tsx';
import AimTester from './pages/AimTester.tsx';
import AIMLeaderBoard from './pages/AIMLeaderBoard.tsx';
import AdminContent from './components/AdminContent.tsx';
import Learning from './pages/Learning.tsx';
import MyContents from './pages/Mycontents.tsx';
import MyPrivateContents from './pages/MyPrivateContents.tsx';
import Mystudydesk from './pages/Mystudydesk.tsx';
import Topcontents from './pages/Topcontents.tsx';
import CrosswordPuzzle from './pages/CrosswordPuzzle.tsx';
import RouteTransitionWrapper from "./components/RouteTransitionWrapper.tsx";
import ScrollToTopButton from "./components/ScrollToTopButton.tsx";
import ValentinCard from "./pages/ValentinCard.tsx";
import ValentineCustomPage from "./pages/ValentineCustomPage.tsx";
import Projects from "./pages/Projects.tsx";
import TermsOfService from "./pages/TermsOfService.tsx";
import CookiePolicy from "./pages/CookiePolicy.tsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";


const App: React.FC = () => {
  return (
    
    <ThemeProvider>
      <CssBaseline />
      <ScrollToTopButton />
      <Router>
        <RouteTransitionWrapper>
          {(delayedLocation) => (
          <Routes location={delayedLocation}> 
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            {/*Footer*/}
            <Route path="/projects" element={<Projects />} />
            <Route path="/termsofservice" element={<TermsOfService />} />
            <Route path="/cookiepolicy" element={<CookiePolicy />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
             {/*Footer END*/}
            {/*VGP*/}
            <Route path="/linklearning" element={<VGP />} />
            {/*VGP END*/}
            {/*LEARNING*/}
            <Route path="/learning" element={<Learning />} />
            <Route path="/mycontents" element={<MyContents />} />
            <Route path="/myprivatecontents" element={<MyPrivateContents />} />
            <Route path="/mystudydesk" element={<Mystudydesk />} />
            <Route path="/topcontents" element={<Topcontents />} />

            {/*LEARNING END*/}
            <Route path="/leaderboard" element={<LeaderBoard />} />
            <Route path="/aimleaderboard" element={<AIMLeaderBoard />} />
            {/*GAMES*/}
            <Route path="/click" element={<Clicker />} />
            <Route path="/aimtester" element={<AimTester />} />
            <Route path="/caseopening" element={<CaseOpening />} />
            <Route path="/catchme" element={<CatchMe />} />
            
            {/*GAMES END*/}
            {/*WEBSITES AND APPS*/}
            <Route path="/encryption" element={<Encryption />} />
            <Route path="/randomizer" element={<Randomizer />} />
            <Route path="/pictureconverter" element={<PictureConverter />} />
            <Route path="/freewebsites" element={<FreeWebSites />} />
            <Route path="/freetrialwebsites" element={<FreeTrialWebSites />} />
            <Route path="/paidwebsites" element={<PaidWebsites />} />
            <Route path="/valentincard" element={<ValentinCard />} />
            <Route path="/valentine-preview" element={<ValentineCustomPage />} />
            {/*<Route path="/adspage" element={<AdsPage />} />*/}
            {/*WEBSITES AND APPS END*/}
            {/* SECURE PATH */}
            <Route element={<ProtectedRoute />}>
              {/*<Route path="/dashboard" element={<Dashboard />} />*/}
              <Route path="/account" element={<Account />} />
              {/*<Route path="/mycv" element={<MyCV />} />*/}
              <Route path="/myscore" element={<MyScore />} />
              <Route path="/shop" element={<Shop />} />
              {/*<Route path="/buytokens" element={<BuyTokens />} /> */}
            </Route>
            {/* SECURE PATH END*/}

            {/* ADMIN SECURE PATH*/}
            <Route element={<AdminProtectedRoute />}>
              <Route path="/admin" element={<Admin />} />
              <Route path="/admincontent" element={<AdminContent />} />
              <Route path="/crosswordpuzzle" element={<CrosswordPuzzle />} />
            </Route>
            {/* ADMIN SECURE PATH END */}
          </Routes>
          )}
        </RouteTransitionWrapper>
      </Router>
    </ThemeProvider>
  );
};

export default App;
